import styled from 'styled-components';
import { flexCenterColumn } from '@/styles/layout';
import { media } from '@/styles/responsive';

export const Wrapper = styled.div`
  ${flexCenterColumn};
  width: 50%;
  row-gap: 58px;

  ${media.tablet`
    width: 100%;
    row-gap: 42px;
  `}
`;
